
/* eslint-disable */
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import Common from './Common';
import Auth from './Auth';
import Settings from './Settings';
import pendingApproval from 'modules/cbre-flow-lab-pending-approval/ducks/reducers';
import SiteLocation from 'modules/cbre-flow-site-location/ducks/reducers';
import UserInfo from 'modules/cbre-flow-api-ducks/reducers';
import AddInstrument from 'modules/cbre-flow-lab-add-instrument/ducks/reducers';
import WorkRequest from 'modules/cbre-flow-lab-new-work-request/ducks/reducers';
import AddOptions from 'modules/cbre-flow-add-new-options/ducks/reducers';
import FilterForm from 'modules/cbre-flow-lab-instrument-filter/ducks/reducers';
import RequestFilterForm from 'modules/cbre-flow-request-filter/ducks/reducers';
import InstrumentDetailsRequestFilterForm from 'modules/cbre-lab-instrument-details-request-filter/ducks/reducers';
import UpcomingMaintenance from 'modules/cbre-flow-lab-upcoming-maintenance/ducks/reducers';
import UserManagement from 'modules/Admin/cbre-flow-user-management/ducks/reducers';
import SearchAddUser from 'modules/Admin/cbre-flow-user-management-search-add-user/ducks/reducers';
import AddClient from 'modules/Admin/cbre-flow-newclient/ducks/reducers';
import AppsList from 'modules/cbre-flow-api-ducks/reducers/apps';
import Approvals from 'modules/cbre-flow-approvals/ducks/reducers';
import FlowApprovalsFilter from 'modules/cbre-flow-approvals-filter/ducks/reducers';
import EntitlementReviewWindow from 'modules/cbre-flow-lab-entitlement-review-window-details/ducks/reducers';
import EntitlementReviewerMakeDecision from 'modules/cbre-flow-lab-entitlement-make-decision/ducks/reducers';
import clients from 'modules/cbre-flow-api-ducks/reducers/clients';
import AdminUserRole from 'modules/cbre-flow-admin-user-role/ducks/reducers';
import Request from 'modules/cbre-flow-requests/reducers/Request';
import InstrumentDetailsRequest from 'modules/cbre-lab-instrument-details-requests/reducers/Request';
import InstrumentDetailsContract from 'modules/cbre-lab-instrument-details-contracts/reducers/index';
import viewManagementReducer from 'modules/cbre-flow-view-management/ducks/reducer';

const rootReducer = (history:any) => ({
  router: connectRouter(history),
  settings: Settings,
  auth: Auth,
  common: Common,
  client: clients,
  addOptions: AddOptions,
  pendingApproval,
  instrumentDetailsContract: InstrumentDetailsContract,
  instrumentDetailsRequest: InstrumentDetailsRequest,
  request: Request,
  viewManagement: viewManagementReducer,
  "cbre-flow-site-location": SiteLocation,
  "cbre-flow-api-ducks": combineReducers({UserInfo, AppsList}),
  "cbre-flow-lab-add-instrument": AddInstrument,
  "cbre-flow-lab-new-work-request": WorkRequest,
  "cbre-flow-lab-instrument-filter": FilterForm,
  "cbre-flow-request-filter": RequestFilterForm,
  "cbre-flow-lab-instrument-details-request-filter": InstrumentDetailsRequestFilterForm,
  "cbre-flow-lab-upcoming-maintenance": UpcomingMaintenance,
  "cbre-flow-approvals": Approvals,
  "cbre-flow-approvals-filter": FlowApprovalsFilter,
  "cbre-flow-lab-entitlement-review-window-details": EntitlementReviewWindow,
  "cbre-flow-lab-entitlement-reviewer-make-decision": EntitlementReviewerMakeDecision,
  "cbre-flow-admin-user-role": AdminUserRole,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;